import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { func, string } from 'prop-types';
import {
  ImageBackground, Button, Flex,
} from '@atoms';

const ImageUploader = ({ image, onImageChange }) => {
  const fileRef = useRef(null);

  const onButtonClick = () => {
    fileRef.current.click();
  };

  return (
    <Flex selfCenter itemsCenter column>
      {image
      && (
        <StyledImageBackground marginBottom="xl" justifyCenter itemsCenter imageSrc={image} />
      )}
      <StyledInput ref={fileRef} type="file" id="file" onChange={onImageChange} />
      <Button.Rectangular
        primary
        padding="xl"
        onClick={onButtonClick}
      >
        Choose a file
      </Button.Rectangular>
    </Flex>
  );
};

const StyledInput = styled.input`
  ${() => css`
    display: none;
  `}
`;

const StyledImageBackground = styled(ImageBackground)`
  ${() => css`
    width: 100%;
    min-height: 150px;
    position: relative;

    ${Button.Circular} {
      position: absolute;
      top: -10px;
      left: -10px;
    }
  `}
`;

ImageUploader.defaultProps = {
  image: '',
};

ImageUploader.propTypes = {
  image: string,
  onImageChange: func.isRequired,
};

export default ImageUploader;
